// react-rails mount entry for `react_component 'InspectionSeries/FrequencyAssets'`
// (app/views/inspection_series/frequency_assets.html.erb). The frontend/packs
// require.context resolves a mounted component by path under frontend/features/, so the
// mount point has to be this file's default export.
import FrequencyAssetsGrid from './FrequencyAssetsGrid';
export default FrequencyAssetsGrid;
